import { Component, Input, OnInit } from "@angular/core";
import { SpinnerComponent } from "../spinner/spinner.component";

@Component({
  selector: "app-chart-placeholder",
  templateUrl: "./chart-placeholder.component.html",
  styleUrls: ["./chart-placeholder.component.scss"],
  standalone: true,
  imports: [SpinnerComponent],
})
export class ChartPlaceholderComponent implements OnInit {
  @Input() loaded = false;

  constructor() {}

  ngOnInit(): void {}
}
